import EditHostnameDialog from './EditHostnameDialog';

export default EditHostnameDialog;
